<template>
  <div>
    <el-button v-if="!isArchiveView" @click="drawer = true" type="primary" style="margin-left: 16px;">
      {{ btnText }}
    </el-button>
    <el-drawer
        :title="title"
        :visible.sync="drawer"
        :direction="direction"
        :size="size">
      <slot></slot>
    </el-drawer>
  </div>
</template>

<script>

export default {
  name: "Drawer",
  props: {
    size: {
      type: String,
      default: "50%",
    },
    title: {
      type: String,
      default: "Drawer Title"
    },
    btnText: {
      type: String,
      default: 'Take Action'
    }
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  inject: {
    // inject a getter function from parent to determine if we are viewing an archived/original applicant
    getApplicantArchiveId: { default: null }
  },
  computed: {
    isArchiveView() {
      try {
        return !!(this.getApplicantArchiveId && typeof this.getApplicantArchiveId === 'function' && this.getApplicantArchiveId());
      } catch (e) {
        return false;
      }
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>